"use client";

import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
export default function CommonQuestions() {
  const faqs = [{
    id: "item-1",
    question: "How long does a typical web design project take?",
    answer: "Most website projects are completed within 7 to 14 business days from the time we receive all required content, images, and project details from the client. Timelines may vary depending on the size and complexity of the project."
  }, {
    id: "item-2",
    question: "Do you offer social media management for all platforms?",
    answer: "Yes, we specialize in Instagram, Facebook, LinkedIn, and TikTok. We tailor our strategy to the platforms where your target audience is most active to ensure maximum engagement and ROI."
  }, {
    id: "item-3",
    question: "What is included in the 'Websites That Work While You Sleep' approach?",
    answer: "It means we build high-converting landing pages and automated SEO strategies that capture leads and drive sales 24/7, even when your physical business is closed."
  }, {
    id: "item-4",
    question: "Can you help with rebranding an existing business?",
    answer: "Absolutely. Our Brand Identity & Logo Design service is perfect for established businesses looking for a modern, premium refresh that aligns with current digital trends."
  }, {
    id: "item-5",
    question: "Is website maintenance included in your packages?",
    answer: "We offer dedicated Website Maintenance plans to keep your site secure, updated, and performing at peak speed. This allows you to focus on running your business while we handle the tech."
  }, {
    id: "item-6",
    question: "Do you work with businesses outside of Sumter, SC?",
    answer: "While we are proud to be based in Sumter, we serve small businesses and entrepreneurs nationwide across the US using advanced digital collaboration tools."
  }];
  return <section data-section-id="239457" id="common-questions" className="bg-background py-12 md:py-20">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6 lg:px-8">
        {}
        <div className="mb-12 text-center">
          <h2 className="font-default mb-4 text-3xl font-bold text-foreground md:text-4xl tracking-tight">
            Common Questions
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-base md:text-lg">
            Everything you need to know about our digital services and how we help your business grow.
          </p>
        </div>

        {}
        <Accordion type="single" collapsible className="w-full space-y-2">
          {faqs.map((faq, i) => <div key={faq.id} data-index={i}>
              <AccordionItem value={faq.id} className="border-border rounded-md border px-4 transition-all duration-300 data-[state=open]:bg-card data-[state=open]:shadow-lg">
                <AccordionTrigger className="text-primary font-default text-base font-semibold hover:text-primary/80 transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-default text-sm leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            </div>)}
        </Accordion>

        {}
        <div className="mt-12 rounded-lg border border-border bg-card/50 backdrop-blur-sm px-6 py-8 text-center shadow-md">
          <p className="font-default mb-4 text-foreground font-medium">
            Still have questions about our process?
          </p>
          <p className="text-muted-foreground mb-6 text-sm">
            Contact our team directly and we'll help you find the perfect digital solution for your business.
          </p>
          <Link to="/ContactPage" className="inline-flex items-center justify-center gap-2 rounded-md bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground transition-all hover:bg-primary/90 hover:shadow-[0_0_15px_rgba(250,204,21,0.3)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
            Get Your Free Quote
          </Link>
        </div>
      </div>
    </section>;
}